<canvas #canvas></canvas>
<canvas id="c2" style="width:150px;height:80px"></canvas>
